module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"cta-description":"Ao clicar no botão acima, o envio será feito apenas para pessoas que ainda não receberam suas mídias. Não é possível reenviá-las para uma mesma pessoa.","cta-label":"Enviar fotos","delivery-error":"Erro ao entregas as mídias. Tente novamente mais tarde.","learn-more":"Saiba mais","title":"Envios","album-not-found":"Álbum não encontrado"}}')
  delete Component.options._Ctor
}
